// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import { PopOver } from 'app/scripts/views/lib/pop-over';

import { CardMoveView } from 'app/scripts/views/card/CardMoveView';
import { stopPropagationAndPreventDefault } from 'app/src/stopPropagationAndPreventDefault';
import { Auth } from 'app/scripts/db/auth';
import _ from 'underscore';
import { Analytics } from '@trello/atlassian-analytics';

// TODO: Remove feature flag after successful deploy according to https://trello.com/c/VGE8H3ka/392-remove-feature-flag-for-copy-cards-date-tbd
import { CardCopyView } from 'app/scripts/views/card/CardCopyView';

const openMoveMenu = function (elem) {
  PopOver.toggle({
    elem,
    view: CardMoveView,
    options: { model: this.model, modelCache: this.modelCache },
  });
};

const openMoveFromHeader = function (e) {
  stopPropagationAndPreventDefault(e);
  this.openMoveMenu(this.$('.js-open-move-from-header'), 20);
  Analytics.sendClickedLinkEvent({
    linkName: 'listNameLink',
    source: 'cardDetailScreen',
    attributes: {
      cardIsTemplate: this.model.get('isTemplate'),
      cardIsClosed: this.model.get('closed'),
    },
    containers: this.model.getAnalyticsContainers(),
  });
};

const openMoveFromBadge = function (e) {
  stopPropagationAndPreventDefault(e);
  this.openMoveMenu(this.$('.js-card-detail-list-badge-button'));
  Analytics.sendUIEvent({
    action: 'clicked',
    actionSubject: 'badge',
    actionSubjectId: 'cardListBadge',
    source: 'cardDetailScreen',
    attributes: {
      cardIsTemplate: this.model.get('isTemplate'),
      cardIsClosed: this.model.get('closed'),
    },
    containers: this.model.getAnalyticsContainers(),
  });
};

const moveCard = function (e) {
  stopPropagationAndPreventDefault(e);
  this.openMoveMenu(this.$('.js-move-card'), 35);
  Analytics.sendClickedButtonEvent({
    buttonName: 'moveButton',
    source: 'cardDetailScreen',
    attributes: {
      cardIsTemplate: this.model.get('isTemplate'),
      cardIsClosed: this.model.get('closed'),
    },
    containers: this.model.getAnalyticsContainers(),
  });
};

const copyCard = function (e) {
  stopPropagationAndPreventDefault(e);

  PopOver.toggle({
    elem: this.$('.js-copy-card'),
    view: CardCopyView,
    options: { model: this.model, modelCache: this.modelCache },
  });
  Analytics.sendClickedButtonEvent({
    buttonName: 'copyCardButton',
    source: 'cardDetailScreen',
    attributes: {
      cardIsTemplate: this.model.get('isTemplate'),
      cardIsClosed: this.model.get('closed'),
    },
    containers: this.model.getAnalyticsContainers(),
  });
};

const renderCopyCard = function () {
  const hasBoards = _.any(
    Auth.me().boardList.models,
    (board) => !board.get('closed'),
  );
  return this.$('.js-copy-card').toggleClass('hide', !hasBoards);
};

export { openMoveMenu };
export { openMoveFromHeader };
export { openMoveFromBadge };
export { moveCard };
export { copyCard };
export { renderCopyCard };
